import { currentLocationStatus } from '../../constants/error';
import { CurrentLocationStatus } from '../../types/location';
import { FormattedMessage } from 'react-intl';
import { LocationHelperTexts } from '../../types/autocomplete';
import { LocationSelectError } from '../location-select-error/LocationSelectError';
import { useEffect } from 'react';
import {
  Arrow,
  ArrowContainer,
  CurrentLocation,
  HelperText,
  LocationAutocomplete,
  LocationLabel,
  Menu,
  MenuContentWrapper,
  SearchIcon,
} from './LocationDropdownStyle';

interface props {
  isOpen: boolean;
}

function LocationDropdown({ isOpen }: props) {
  const helperText: LocationHelperTexts = {
    default: {
      element: (
        <HelperText>
          <FormattedMessage id='generic.locationHelperTexts.default' />
        </HelperText>
      ),
    },
    invalidInput: {
      element: (
        <HelperText hasError>
          <FormattedMessage id='generic.locationHelperTexts.invalidLocation' />
        </HelperText>
      ),
    },
  };

  useEffect(() => {
    // Resets the current location status on the closing of the component
    return function reset() {
      currentLocationStatus.next(CurrentLocationStatus.NONE);
    };
  }, []);

  return isOpen ? (
    <Menu className='location-navlink-menu'>
      <ArrowContainer>
        <Arrow />
      </ArrowContainer>
      <MenuContentWrapper>
        <LocationLabel>Where is your jobsite?</LocationLabel>
        <LocationAutocomplete
          resetCurrentLocationOnClickAway={false}
          hideStartIcon={true}
          endIcon={<SearchIcon />}
          popupPosition='relative'
          helperText={helperText}
        />
        <LocationSelectError />
        <CurrentLocation />
      </MenuContentWrapper>
    </Menu>
  ) : null;
}

export default LocationDropdown;
